import { Component, OnInit, Input } from '@angular/core';
import { Order } from '../../models/order';
import { OrderLine } from '../../models/order-line';
import { environment } from '../../../../../environments/environment';
import { DropDownItem } from '../../../general/components/dropdown/dropdown.item';
import { DiscountCoupon } from '../../../payment/models/discount-coupon';
import { BasketService } from '../../services/basket.service';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-basket-view',
  templateUrl: './basket-view.component.html',
  styleUrls: ['./basket-view.component.css']
})

export class BasketViewComponent implements OnInit {

  @Input()
  order: Order;

  @Input()
  readonly: boolean;

  faPlus = faPlus;
  faMinus = faMinus;

  constructor(
    private basketService: BasketService,
  ) {
  }

  ngOnInit(): void {
  }

  reduceQuantityOrderLine(orderLine: OrderLine): void {
    this.order.reduceQuantityOrderLine(orderLine, orderLine.quantity);
  }

  toMoneyStr(x: number): string {
    if (typeof x !== 'number') {
      return '';
    }

    return environment.globalSettings.toMoneyStr(x);
  }

  generateDropDownItems(count: number): DropDownItem[] {
    return Array(count).fill(1).map((x, i) => new DropDownItem((i + 1), (i + 1).toString()));
  }

  canRemoveLine(orderLine: OrderLine): boolean {
    return !this.readonly && !orderLine.readonly && this.order.orderLines.length > 1;
  }

  canChangeQuantity(orderLine: OrderLine): boolean {
    return !this.readonly && !orderLine.readonly;
  }

  maximumCount(orderLine: OrderLine): number {
    return Math.max(10, orderLine.quantity);
  }

  get orderLines(): OrderLine[] {
    return this.order.orderLines.filter(x => !x.coupon);
  }

  get coupons(): DiscountCoupon[] {
    return this.order ? this.order.coupons : new Array<DiscountCoupon>();
  }

  get total(): number {
    return this.order.totalAmount - DiscountCoupon.getTotalDiscountCouponAmount(this.coupons);
  }

  get discountAmount(): number {
    return DiscountCoupon.getTotalDiscountCouponAmount(this.coupons);
  }

  onLineItemMinus(orderLine: OrderLine): void {
    if (orderLine.quantity > 1) {
      orderLine.quantity--;
    }
  }

  onLineItemAdd(orderLine: OrderLine): void {
    orderLine.quantity++;
  }

  get dates(): Date[] {
    return this.basketService.getDates(this.order);
  }

  getOrderLines(date: Date): OrderLine[] {
    return this.basketService.getOrderLines(this.order, date);
  }

  getGroupHeaderParams(date: Date): any {
    return this.basketService.getGroupHeaderParams(this.order, date);
  }
}
